module.exports = __webpack_public_path__ + "img/lifebuoy.17a9cebe.svg";